import { OrderItem } from '@mews-commander/types';
import { getServiceOrder } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector } from '@mews-commander/utils';

import { OrderItemListItem } from '../OrderItemListItem';

interface OwnProps {
    orderItem: OrderItem;
}

export const UngroupedServiceOrderItem = ({ orderItem }: OwnProps) => {
    const serviceOrder = useCommanderSelector((state) => getServiceOrder(state, { id: orderItem.serviceOrderId }));

    return (
        <OrderItemListItem
            orderItemId={orderItem.id}
            orderItem={orderItem}
            serviceId={serviceOrder?.serviceId || ''}
            showNotes
        />
    );
};
